export const GET_PBSS_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_PBSS_REQUEST";
export const GET_PBSS_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_PBSS_SUCCESS";
export const GET_PBSS_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_PBSS_FAILURE";
